import { ref, watch } from 'vue'
import { FrontendApi, Configuration } from '@ory/client-fetch'
import { useAuthStore } from '@/stores/auth'

export function useOryLogout() {
  const logoutUrl = ref<string | null>(null)
  const loading = ref(false)
  const authStore = useAuthStore()

  const oryUrl = (window as any).APP_CONFIG?.ORY_URL || "http://localhost:4000"

  // Initialize Ory client with Accept: application/json header
  const ory = new FrontendApi(
    new Configuration({
      basePath: oryUrl,
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
      },
    }),
  )

  const createLogoutUrl = async () => {
    // Only create logout URL if user is authenticated
    if (!authStore.isAuthenticated) {
      logoutUrl.value = null
      return
    }

    try {
      loading.value = true
      const logoutData = await ory.createBrowserLogoutFlow()

      // Append return_to parameter so user is redirected back to our app
      if (logoutData.logout_url) {
        const url = new URL(logoutData.logout_url)
        url.searchParams.set('return_to', window.location.origin)
        logoutUrl.value = url.toString()
      } else {
        logoutUrl.value = null
      }
    } catch (error) {
      console.error("Error creating logout URL:", error)
      logoutUrl.value = null
    } finally {
      loading.value = false
    }
  }

  // Watch for authentication changes and create/clear logout URL accordingly
  watch(
    () => authStore.isAuthenticated,
    async (isAuthenticated) => {
      if (isAuthenticated) {
        await createLogoutUrl()
      } else {
        logoutUrl.value = null
      }
    },
    { immediate: true }
  )

  return {
    logoutUrl,
    loading,
    createLogoutUrl
  }
}
